// import { useState } from "react";
import EventCardForPendingVendor from "./EventCardForPendingVendor";
import { parse } from "date-fns";
import { eventVsVenue } from "../../../services/eventVsVenue";
import { Grid } from "@mui/material";

export const EventListForPendingVendor = ({
  events,
  venueData,
  safety = [],
}) => {
  const parseDate = (date) => {
    try {
      if (date !== null && date !== undefined) {
        return parse(date, "yyyy-MM-dd", new Date());
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const parseTime = (time) => {
    try {
      if (time !== null && time !== undefined) {
        return parse(time, "HH:mm:ss", new Date());
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  return (
    <div className="event_list">
    <Grid container spacing={3}>
      {events &&
        (events ?? [])?.map((event, idx) => {
          let eventVenue;
          let safetyCheck;
          for (const item of safety) {
            if (item === event.id.toString()) {
              safetyCheck = true;
            }
          }
          for (const venue of venueData ?? []) {
            if (event?.venue?.[0] === venue.id) {
              eventVenue = venue;
            }
          }
 
          return (
            <EventCardForPendingVendor
              key={idx}
              eventImage={eventVsVenue(event.img_url, eventVenue.img_url)}
              eventName={event.name}
              eventStart={
                event.start_date !== undefined
                  ? parseDate(event.start_date)
                  : new Date(event.start)
              }
              eventEnd={
                event.end_date !== undefined
                  ? parseDate(event.end_date)
                  : new Date(event.end)
              }
              eventHours={event.hours}
              eventHoursStart={parseTime(
                eventVsVenue(event.start_hours, eventVenue.start_hours),
              )}
              eventHoursEnd={parseTime(
                eventVsVenue(event.end_hours, eventVenue.end_hours),
              )}
              eventStreet1={eventVenue.street1}
              eventCity={eventVenue.city}
              eventUrl={event.id}
              legacy={event.legacy === true ? "/legacy" : ""}
              legacyEvent={event.legacy}
              safetyCheck={safetyCheck}
              facebookUrl={event.facebook_link}
              eventId={event.id}
              eventStatus={event.open_status === "open soon"}
            />
          );
        })}
        </Grid>
    </div>
  );
};

export default EventListForPendingVendor;
